import React, { useState } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function AddProfileDetails() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const [blood,setBlood] = useState("");
    const [doj,setDoj] = useState("");
    const [qualification,setQualification] = useState("");
    const [Graduation,setGraduation] = useState("");
    const [stream,setStream] = useState("");
    const [area,setArea] = useState("");
    const [permanent,setPermanent] = useState("");
    const [temporary,setTemporary] = useState("");
    const [image, setImage] = useState(null);
    const [working,setWorking] = useState("");
    const [notice,setNotice] = useState("");
    const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              },
            });
    function hanldeWorking() {
        var wor = document.getElementById('work').value;
        if (wor === 'yes'){
            document.getElementById('notice').style.display = 'none';
        } else if (wor === 'no'){
            document.getElementById('notice').style.display = 'block';
        }
        setWorking(wor);
    }
    function AddDetails(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('ID',ID);
        formdata.append('blood',blood);
        formdata.append('doj',doj);
        formdata.append('qualification',qualification);
        formdata.append('graduation',Graduation);
        formdata.append('stream',stream);
        formdata.append('area',area);
        formdata.append('permanent',permanent);
        formdata.append('temporary',temporary);
        formdata.append('working',working);
        formdata.append('notice',notice);
        formdata.append('image',image);
        axios.post(`${url.path}/add_details/`,formdata)
        .then((res) =>{
            if (res.data.status){
                Toast.fire({
                    icon:"success",
                    title:"Profile Details Added.."
                });
                navigate("/profile");
            }
        })
        .catch((err) => {
            Toast.fire({
                icon:'error',
                title: err,
            });
          });
    }
    return(
        <>
        <Navbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Add Profile Details</h1>
                </div>
                <br />
                <form onSubmit={AddDetails}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Blood Group</label>
                            <input type="text" value={blood} onChange={(e) =>setBlood(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Date of Joining</label>
                            <input type="date" value={doj} onChange={(e) =>setDoj(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Qualification</label>
                            <input type="text" value={qualification} onChange={(e) =>setQualification(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Graduation Year</label>
                            <input type="date" value={Graduation} onChange={(e) =>setGraduation(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Stream</label>
                            <input type="text" value={stream} onChange={(e) =>setStream(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Area Of Interest</label>
                            <input type="text" value={area} onChange={(e) =>setArea(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Permanent Address</label>
                            <input type="text" value={permanent} onChange={(e) =>setPermanent(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Temporary Address</label>
                            <input type="text" value={temporary} onChange={(e) =>setTemporary(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Currently Working or Not</label>
                            <select value={working} onChange={hanldeWorking} id="work">
                                <option value="" selected>--Select--</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                        <div className="form-group" style={{display:'none'}} id="notice">
                            <label>Notice Period</label>
                            <input type="text" value={notice} onChange={(e) =>setNotice(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Profile Image</label>
                            <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">ADD</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default AddProfileDetails;